class CartRecommendations extends HTMLElement {
  constructor() {
    super();
    this.swiperInstance = null;
  }

  connectedCallback() {
    // Initialize Swiper when element is connected
    this.initializeSwiper();
    // Update visibility based on current cart state
    this.updateVisibility();
  }

  initializeSwiper() {
    // Destroy existing Swiper instance if present
    if (this.swiperInstance) {
      this.swiperInstance.destroy(true, true);
      this.swiperInstance = null;
    }

    // Find swiper container
    const swiperWrapper = this.querySelector('.cart-drawer-recommendations-swiper');
    if (!swiperWrapper) return;

    const swiperContainer = swiperWrapper.querySelector('.swiper');
    if (!swiperContainer) return;

    if (typeof Swiper === 'undefined') {
      this._swiperRetryCount = (this._swiperRetryCount || 0) + 1;
      if (this._swiperRetryCount <= 25) {
        setTimeout(() => this.initializeSwiper(), 100);
      }
      return;
    }
    this._swiperRetryCount = 0;

    // Get visible slides (not in cart)
    const visibleSlides = swiperContainer.querySelectorAll('.swiper-slide:not(.is-in-cart)');
    if (visibleSlides.length === 0) return;

    // Initialize Swiper with responsive breakpoints
    this.swiperInstance = new Swiper(swiperContainer, {
      slidesPerView: 2,
      spaceBetween: 16,
      loop: false,
      watchOverflow: true,
      breakpoints: {
        750: {
          slidesPerView: 3,
          spaceBetween: 20,
        },
      },
      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true,
        type: 'bullets',
      },
    });
  }

  async updateVisibility() {
    try {
      const cart = await fetch('/cart.js', {
        headers: { Accept: 'application/json' },
      }).then((r) => r.json());

      if (!cart || !cart.items) return;

      // Get product IDs in cart
      const cartProductIds = new Set(cart.items.map((item) => String(item.product_id)));

      // Update visibility of slides
      const slides = this.querySelectorAll('.swiper-slide[data-product-id]');
      let hasChanges = false;

      slides.forEach((slide) => {
        const productId = slide.getAttribute('data-product-id');
        const isInCart = cartProductIds.has(productId);

        if (isInCart && !slide.classList.contains('is-in-cart')) {
          slide.classList.add('is-in-cart');
          slide.style.display = 'none';
          hasChanges = true;
        } else if (!isInCart && slide.classList.contains('is-in-cart')) {
          slide.classList.remove('is-in-cart');
          slide.style.display = '';
          hasChanges = true;
        }
      });

      // Reinitialize Swiper if visibility changed
      if (hasChanges) {
        if (this.swiperInstance) {
          this.swiperInstance.update();
        } else {
          this.initializeSwiper();
        }
      }
    } catch (e) {
      console.error('[CartRecommendations]', e);
    }
  }
}

if (!customElements.get('cart-recommendations')) {
  customElements.define('cart-recommendations', CartRecommendations);
}

